import React from "react";

import { ButtonWidget } from "@caelor/ui";
import {
  ButtonBlockContainer,
  ButtonEditorContainer,
  ButtonEditorSkeleton,
  ButtonEditorSkeletonContainer,
} from "./styles";
import { useButtonStore } from "../../../../stores/use-button-store";
import { urlValidator } from "../../../../helpers/validators";

const ButtonEditor = () => {
  const { data, setData } = useButtonStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  return (
    <ButtonEditorContainer>
      <ButtonEditorSkeletonContainer>
        <ButtonEditorSkeleton />
        <ButtonEditorSkeletonContainer gap="8px">
          {Array.from({ length: 3 }).map(() => (
            <ButtonEditorSkeleton height="16px" />
          ))}
          <ButtonEditorSkeleton width="240px" height="16px" />
        </ButtonEditorSkeletonContainer>
        <ButtonBlockContainer align={data.align}>
          <ButtonWidget
            data={data}
            isEditable={true}
            onClick={() => {
              if (urlValidator({ url: data.url?.link, protocols: ["https:"] }))
                window.open(data.url?.link, data.newTab ? "_blank" : "_top");
            }}
            setData={setData}
          />
        </ButtonBlockContainer>
      </ButtonEditorSkeletonContainer>
    </ButtonEditorContainer>
  );
};

export default ButtonEditor;
